module.exports = __webpack_public_path__ + "img/fusibles_y_portafusibles.d0449cfc.jpg";